import { useTranslation } from '../../store/context/TranslationContext';
import { Button } from 'reactstrap';
import "./style.css"
import { ThreeBounce } from 'better-react-spinkit';

const FormChangeConfirmation = ({
    onClickNo = () => { },
    onClickYes = () => { },
    config = {
        title: "",
        noButtonText: "",
        yesButtonText: "",
        btnWidth: ""
    },
    loading = false
}) => {
    const { t } = useTranslation();
    return (
        <div className='p-4 container-box'>
            {config.title ? <div className='text-center container-text'>
                {t(config.title)}
                <span className='text-danger ms-1'>*</span>
            </div> : null}

            <div className={`d-flex align-items-center flex-column flex-md-row justify-content-evenly gap-3 mt-${config.title ? "4" : "0"}`}>
                <Button
                    disabled={loading}
                    style={{ width: config.btnWidth }} className='fs-5 rounded-pill text-black btn-outline-dark px-4 fv-btn-transparent'
                    onClick={onClickNo}
                >
                    {loading ? <ThreeBounce color='black' /> : t(config.noButtonText)}
                </Button>
                <Button
                    disabled={loading}
                    style={{ width: config.btnWidth }} className='fs-5  rounded-pill bg-black px-4'
                    onClick={onClickYes}
                >
                    {loading ? <ThreeBounce color='white' /> : t(config.yesButtonText)}
                </Button>
            </div>
        </div>
    )
}

export default FormChangeConfirmation;